module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-7 col-md-6 col-12"
  }, [_c('ul', {
    staticClass: "social-list list-inline"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story",
      "target": "_blink"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("facebook")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("instagram")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("twitter")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-txt small"
  }, [_vm._v("\n            Copyright © 2017 weddingsung.com. All Rights Reserved.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-5 col-md-6 col-12 align-self-end"
  }, [_c('p', {
    staticClass: "copyright-txt copyright-cc clearfix"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by-nc-sa/4.0/"
    }
  }, [_c('img', {
    staticStyle: {
      "border-width": "0"
    },
    attrs: {
      "alt": "創用 CC 授權條款",
      "src": "https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "pull-left small",
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by-nc-sa/4.0/"
    }
  }, [_vm._v("本著作係採用 創用 CC 姓名標示-非商業性-相同方式分享 4.0 國際 授權條款授權.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97236594","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footbar.vue
// module id = 170
// module chunks = 1